import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const CounselingSen = () => {    
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/learning-app.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Facilities" breadEnd="Learning Approach" breadMid="Counseling & Sen" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h4 className="color-red">Counseling & Sen</h4>
                            <div class="lab-heading mb-4">
                                <div class="lab-btn" id="mb-lab-btn"><span>Labs</span></div>
                                <ul class="labs-list">
                                    <li><a class="" href="/mathmatics">Mathematics</a></li>
                                    <li><a class="" href="/physics">Physics</a></li>
                                    <li><a class="" href="/biology">Biology</a></li>
                                    <li><a class="" href="/chemistry">Chemistry</a></li>
                                    <li><a class="" href="/language">Language</a></li>
                                    <li><a class="" href="/computer">Computer</a></li>
                                    <li><a class="" href="/robotics">Robotics</a></li>
                                    <li><a class="" href="/hands-on-studio">Hands On Studio</a></li>
                                    <li><a class="" href="/psychology">Psychology</a></li>
                                    <li><a class="inc-tlink-active" href="/counseling-sen">Counseling &amp; Sen </a></li>
                                </ul>
                            </div>
                            
                            <p>We at Lotus Valley believe that accomplishing educational recognition is incomplete without an integrated system. The Counselling and SEN department plays a key role in the fields of inclusion, well-being, and integration, promoting a barrier-free conducive atmosphere in the school. At Lotus Valley, inclusion is both a procedure and an ideology.</p>
                            <p>The school provides a dedicated Counselling and SEN department that has been focused on the integration of special needs through an enriched curriculum and methodology, with attention on the capacity building of the child's social, emotional, mental, and cognitive growth. To provide a coordinated and supportive approach, both teaching and non-teaching professionals are informed and trained on the specifics of special needs. In a nutshell, we as a department:</p>
                            
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/counseling-sen.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <ul className="admission-list">
                                <li>Conduct Group Counselling sessions on various topics like Puberty, Adolescence, World Autism Day, World Mental health Day, International Day for People with Disabilities, etc.</li>
                                <li>Conduct Individual Counselling sessions</li>
                                <li>Do basic assessment for academic concerns before advising for a formal assessment to understand the need and current level of the referred learners.</li>
                                <li>Involve all stakeholders in ensuring the holistic development of the learner.</li>
                                <li>Prepare Academic and behavioural remediation plans (IEPs).</li>
                                <li>Assist learners with examinations and graded papers according to their academic level.</li>
                                <li>Synchronize with external initiatives to ensure continued progress.</li>
                                <li>Are responsible for the coordination of Vocational Education Club- Mother Teresa</li>
                            </ul>
                            <p>Contact us at counsellors@lotusvalleygurgaon.com</p>
                        </div>

                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default CounselingSen